import { render, staticRenderFns } from "./StudentFeeReport.vue?vue&type=template&id=6d75b683"
import script from "./StudentFeeReport.vue?vue&type=script&lang=js"
export * from "./StudentFeeReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports